/*
 * A read-only `[label] [value]` row inside a `<dl>`.
 *
 * It is deliberately inert: no chevron, no button, no link, no hover state and
 * no tap affordance. A chevron in this system means "this navigates or acts",
 * so a row that does neither must never render one. Editability, when it
 * eventually exists for a field, is introduced by giving that field its own
 * control — not by decorating this row.
 *
 * An absent value renders the shared `Not set` placeholder so an empty field
 * still reads as a field rather than as a rendering gap.
 */
export default function SettingsValueRow({ label, value, placeholder = "Not set" }) {
  const isEmpty = value == null || value === "";

  return (
    <div className="lz-settings-value-row">
      <dt className="lz-settings-value-row__label">{label}</dt>
      <dd
        className={
          isEmpty
            ? "lz-settings-value-row__value lz-settings-value-row__value--placeholder"
            : "lz-settings-value-row__value"
        }
      >
        {isEmpty ? placeholder : value}
      </dd>
    </div>
  );
}
